import React from 'react';
import { Jumbotron, Container, Row, Col} from 'reactstrap';
import { Dictionary } from "@utils";

interface HeaderProps {
    data: any;
    followupLabels: Dictionary<string, string>;
}

const Header: React.FC<any> = ({data, followupLabels}: HeaderProps) => { 
    return (
        <Jumbotron fluid style={{borderRadius:"10px", padding: "1.5rem", width:"100%", backgroundColor:"rgba(213, 213, 213, 0.25)"}}>
            <Container fluid>
                <Row style={{width:"100%", paddingBottom:"1.5rem"}}>
                    <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{paddingBottom: "0.5rem"}}>
                        <strong style={{color:"#f03500"}}>{followupLabels.get("headerProject")}: </strong>
                    </Col>
                    <Row style={{paddingLeft: "2.5rem", width:"100%"}}>
                        <Col><strong>{followupLabels.get("headerTitle")}: </strong>{data.projectTitle}</Col>
                        <Col><strong>{followupLabels.get("headerCode")}: </strong>{data.projectCode}</Col>
                        <Col><strong>{followupLabels.get("headerCountry")}: </strong>{data.country}</Col>
                        <Col><strong>{followupLabels.get("headerInterventionLine")}: </strong>{data.intLineTitle}</Col>
                    </Row>                                
                </Row>                
                <Row style={{width:"100%", paddingBottom:"1.5rem"}}>
                    <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{paddingBottom: "0.5rem"}}>
                        <strong style={{color:"#f03500"}}>{followupLabels.get("headerSubProject")}: </strong>
                    </Col>
                    <Row style={{paddingLeft: "2.5rem", width:"100%"}}>
                        <Col><strong>{followupLabels.get("headerFinancer")}: </strong>{data.financer}</Col>
                        <Col><strong>{followupLabels.get("headerGrantCode")}: </strong>{data.subvCode}</Col>
                        <Col><strong>{followupLabels.get("headerStartDate")}: </strong>{data.startDate}</Col>
                        <Col><strong>{followupLabels.get("headerEndDate")}: </strong>{data.endDate}</Col>
                    </Row>                                
                </Row>                
                <Row style={{width:"100%"}} id="IndicatorsTourStep2">
                    <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{paddingBottom: "0.5rem", textAlign:"center"}}>
                        <h5 style={{color:"#f03500", margin:"0px"}}>{data.year} - {data.allow}</h5>
                    </Col>                                                   
                </Row>            
            </Container>
        </Jumbotron>
    );
}

export default Header;